import { requestCandidates } from '@app/services/CandidateService';
import { capitalizeName } from "@app/utils/CommonUtils";
import { DVTJCUVSearchCddJobParentTabs } from "@pages/dvtjcuv/common/SearchCddJobTabs";
import DVTJCUVSearchCddJobContent from "@pages/dvtjcuv/rundvtjcuv/search/searchcddjob/DVTJCUVSearchCddJobContent";
import DVTJCUVSearchCddJobHeader from "@pages/dvtjcuv/rundvtjcuv/search/searchcddjob/DVTJCUVSearchCddJobHeader";
import DVTJCUVSearchCddJobNotes from '@pages/dvtjcuv/rundvtjcuv/search/searchcddjob/DVTJCUVSearchCddJobNotes';
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';

const DVTJCUVSearchCddJobModal = (props) => {
    const [cdd, setCdd] = useState({
        id: '',
        full_name: '',
        displayed_company: '',
        displayed_title: '',
        local_province_email: '',
        industry: '',
        function: '',
    });

    const [currentTab, setCurrentTab] = useState(
        DVTJCUVSearchCddJobParentTabs.SET_RECEIVER_LIST_TAB
    );

    const {cddId, tabId, isShow, onClose} = props

    const fetchCandidates = async (canId) => {
        const params = {
            search_conditions: {
                candidate_id: canId
            }
        };

        const res = await requestCandidates(params);
        const candidates = res.content?.candidates;
        if (candidates && candidates.length > 0) {
            const can = candidates[0]
            const displayCan = {id: cddId}
            if (can.personal) {
                displayCan.full_name = capitalizeName(can.personal.full_name)
            }
            if (can.general) {
                displayCan.displayed_company = can.general.displayed_company
                displayCan.displayed_title = can.general.displayed_title
            }
            if (can.location) {
                displayCan.local_province_email = can.location.local_province_email
            }
            if (can.categories) {
                displayCan.industry = can.categories.industry
                displayCan.function = can.categories.function
            }
            setCdd(displayCan)
        }
    };

    useEffect(() => {
        (async () => {
            await fetchCandidates(cddId);
        })();
    },[cddId])

    const activeTab = (tab) => {
        if (currentTab.id === tab.id) {
            return 'active'
        }
        return ''
    }

    const onTabClicked = async (tab) => {
        console.log('change tab root')
        setCurrentTab({...tab});
    };

    const getTabTitle = (tab) => {
        // const total = tabTotals[tab.id] ? tabTotals[tab.id] : 0
        // return `${tab.title} (${total})`
        return tab.title
    }

    return (
        <>
            <Modal show={isShow}
                   fullscreen
                   onHide={onClose}
                   animation={false} style={{zIndex: 3002}}>
                <Modal.Header>
                    <Modal.Title>Tìm job cho Cdd</Modal.Title>
                    <Button variant='secondary' onClick={onClose}>
                        Close
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <div className="card card-default" style={{minHeight: '70vh'}}>
                        <DVTJCUVSearchCddJobHeader cddInfo={cdd}/>
                        <div className="card-body p-0">
                            <ul className='nav nav-tabs' role='tablist'>
                                {Object.values(DVTJCUVSearchCddJobParentTabs).map(tab => (
                                    <li className='nav-item' key={tab.id}>
                                        <a className={`nav-link ${activeTab(tab)}`} data-toggle='tab'
                                           href={`#${tab.id}`}
                                           onClick={() => {
                                               setCurrentTab(tab);
                                               window.location.hash = tab.id;
                                           }}>
                                            {getTabTitle(tab)}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                            <div className='tab-content'>
                                {Object.values(DVTJCUVSearchCddJobParentTabs).map((tab, index) => {
                                    if (currentTab.id === tab.id) {
                                        return <div id={tab.id} className={`tab-pane active`}>
                                            {tab.id === DVTJCUVSearchCddJobParentTabs.SET_RECEIVER_LIST_TAB.id &&
                                                <DVTJCUVSearchCddJobNotes cddId={cddId}/>
                                            }

                                            <DVTJCUVSearchCddJobContent
                                                parentTab={currentTab} cddId={cddId} onChangeRootTab={onTabClicked}
                                            />
                                        </div>
                                    }
                                    return ""
                                })}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
)
}

export default DVTJCUVSearchCddJobModal;
